module.exports = "<div class=\"gmap-container\">\r\n  <app-location-map [isEditMode]=\"false\" [lat]=\"lat\" [lng]=\"lng\"></app-location-map>\r\n</div>\r\n"